import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  aboutData: null,
};

export const getAbout = createAsyncThunk(
  "about/getAbout",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`home/about-us`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);

    }
  }
);

const homeAboutUsSlice = createSlice({
  name: "about",
  initialState,
  reducers: {},
  extraReducers: {
    [getAbout.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getAbout.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.aboutData = action.payload?.data;
    },
    [getAbout.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default homeAboutUsSlice.reducer;
